import { md5 } from './crypto'

/**
 * 管理员登录
 * @param {string} username - 用户名
 * @param {string} password - 明文密码
 * @returns {Promise} 登录结果
 */
export async function adminLogin(username, password) {
  const { adminApi } = await import('../api/index')
  
  const loginData = { username, password: md5(password) }
  
  try {
    const response = await adminApi.login(loginData)
    const token =
      (typeof response === 'string' ? response : null) ||
      (response && response.data && response.data.token) ||
      (response && response.data) ||
      (response && response.token) ||
      null
    if (token) {
      localStorage.setItem('admin_token', token)
      return { success: true, token }
    }
    return { success: false, message: (response && (response.msg || response.message)) || '登录失败' }
  } catch (error) {
    return { success: false, message: error.message }
  }
}

/**
 * 修改管理员密码
 * @param {number} userId - 用户ID
 * @param {string} newPassword - 新密码（明文）
 * @returns {Promise} 修改结果
 */
export async function changeAdminPassword(userId, newPassword) {
  const { adminApi } = await import('../api/index')
  
  const passwordData = {
    id: userId,
    newPassword: md5(newPassword)
  }
  
  try {
    const response = await adminApi.changePassword(passwordData)
    const message =
      (typeof response === 'string' ? response : null) ||
      (response && response.message) ||
      (response && response.data) ||
      '密码修改成功'
    return { success: true, message }
  } catch (error) {
    return { success: false, message: error.message }
  }
}

/**
 * 获取存储的JWT令牌
 * @returns {string|null} JWT令牌
 */
export function getAdminToken() {
  return localStorage.getItem('admin_token')
}

/**
 * 清除管理员认证信息
 */
export function clearAdminAuth() {
  localStorage.removeItem('admin_token')
}

/**
 * 检查是否已登录
 * @returns {boolean} 是否已登录
 */
export function isAdminLoggedIn() {
  return !!getAdminToken()
}

export function parseJwt(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = window.atob(base64)
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export function getAdminId() {
  const token = getAdminToken()
  if (!token) return null
  const payload = parseJwt(token)
  if (!payload) return null
  return payload.admin_id || payload.adminId || payload.id || null
}
